import { SAVED_CART_API } from "../constants/api";
import {
  getHeadersWithTokenAndTraderId,
  getUrl,
  optionsGet,
  optionsPost,
} from "./commonService";
import customAxios from "./customAxios";

export default class SavedCartService {
  getSavedCartService(params: any) {
    let api = SAVED_CART_API.LIST;
    api = api.replace("#ADDRESSID#", params.addressId);

    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }

  saveSavedCart(params: any) {
    const url = getUrl(SAVED_CART_API.SAVE);

    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsPost(url, headers, params.detail);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }
}
